<template>
	<div ref="tablePage" style="height: 100%">
		<div class="topNav">
			<div class="navFormWrapper">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/garage/index' }">车库管理</el-breadcrumb-item>
					<el-breadcrumb-item>车位管理</el-breadcrumb-item>
				</el-breadcrumb>
				<el-form ref="queryForm" :model="searchForm" inline label-width="68px" style="margin-left: 20px">
					<el-form-item style="margin-bottom: 0">
						<el-input v-model="searchForm.carport_title" autocomplete="off" maxlength="30"
							placeholder="车位编号" clearable @clear="clearInputs" size="small" />
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-select style="width: 100%" placeholder="楼层名称" clearable size="small" @change="searchChange"
							@clear="clearInput" v-model="searchForm.floor_id">
							<el-option v-for="item in floorArr" :key="item.id" :label="item.title" :value="item.id" />
						</el-select>
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-select style="width: 100%" placeholder="租售类型" clearable size="small" @change="searchChange"
							@clear="clearRentSaleTypes" v-model="searchForm.rent_sale_type">
							<el-option v-for="item in rentSaleTypes" :key="item.id" :label="item.title"
								:value="item.id" />
						</el-select>
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-button type="primary" icon="el-icon-search" @click="searchChange"
							size="small">搜索</el-button>
						<el-button icon="el-icon-plus" type="success" @click="handleNewAdd"
							size="small">新增车位</el-button>
						<el-button type="info" icon="el-icon-download" @click="fileAdd" size="small">导入</el-button>
						<el-button type="info" icon="el-icon-upload2" @click="postTrue" size="small">导出</el-button>
						<el-button icon="el-icon-delete" type="danger" @click="batchDel" size="small">批量删除</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<el-table :data="tableList" style="width: 100%; margin-top: 2vh" border size="mini"
			@selection-change="handleSelectionChange" :header-cell-style="{
        background: '#fff',
        height: '50px',
        color: '#909399',
        fontSize: '16px',
        fontFamily: 'Arial, sans-serif',
      }">
			<el-table-column type="selection" width="55" align="center">
			</el-table-column>
			<el-table-column prop="id" label="车位ID" align="center" />
			<el-table-column prop="carport_title" label="车位编号" align="center" />
			<el-table-column prop="carport_type" label="车位类型" align="center" />
			<el-table-column prop="rent_sale_type" label="租售类型" align="center">
				<template slot-scope="scope">
					{{getRentSaleTypeTitle(scope.row.rent_sale_type)}}
				</template>
			</el-table-column>
			<el-table-column prop="title" label="车位图片" align="center">
				<template slot-scope="scope">
					<el-image :src="scope.row.carport_thumb" :preview-src-list="[scope.row.carport_thumb]"
						style="width: 50px; height: 50px"></el-image>
				</template>
			</el-table-column>
			<el-table-column prop="price" label="价格" align="center" />
			<el-table-column prop="carport_status" label="车位状态" align="center">
				<template slot-scope="scope">
					<el-tag v-if="scope.row.carport_status == 0" type="info" size="medium">已售</el-tag>
					<el-tag v-if="scope.row.carport_status == 1" type="success" size="medium">在售</el-tag>
					<el-tag v-if="scope.row.carport_status == 2" type="info" size="medium">锁定</el-tag>
					<el-tag v-if="scope.row.carport_status == 4" type="info" size="medium">销控</el-tag>
					<el-tag v-if="scope.row.carport_status == 5" type="danger" size="medium">已租赁</el-tag>
					<el-tag v-if="scope.row.carport_status == 6" type="warning" size="medium">签约</el-tag>
					<el-tag v-if="scope.row.carport_status == 7" type="danger" size="medium">认购</el-tag>
				</template>
			</el-table-column>
			<el-table-column fixed="right" label="操作" align="center">
				<template slot-scope="scope">
					<el-button @click.native.prevent="handleClick(scope.row)" type="primary" size="small"
						icon="el-icon-edit">
						修改
					</el-button>
					<el-button @click.native.prevent="singleDel(scope.row, scope.row.id)" type="danger" size="small"
						icon="el-icon-delete">
						移除
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<pagination v-show="total > 0" :total="total" :page.sync="searchForm.page" :limit.sync="searchForm.pageSize"
			@pagination="initList" />
		<!-- 导出弹窗 -->
		<el-dialog :title="title" :visible.sync="postOpen" :close-on-click-modal="false" width="30%"
			class="global-dialog-position" :before-close="getouts" style="margin-top: -10vh">
			<el-form ref="floorRule" :model="floorId" :rules="floorRule" label-width="150px">
				<el-form-item label="请选择导出楼层" prop="floor_id">
					<el-select v-model="floorId.floor_id" placeholder="请选择" clearable style="width: 100%" size="mini">
						<el-option v-for="item in floorArr" :key="item.id" :label="item.title" :value="item.id" />
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="postSubmit">确定导出</el-button>
				<el-button @click="getouts">取 消</el-button>
			</div>
		</el-dialog>
		<!-- 导入弹窗 -->
		<el-dialog :title="title" :visible.sync="importOpen" :close-on-click-modal="false" width="30%"
			class="global-dialog-position" :before-close="getouts" style="margin-top: -10vh">
			<el-form ref="floorId" label-width="100px">
				<el-form-item label="请选择楼层" required>
					<el-select v-model="floorId.floor_id" placeholder="请选择" clearable style="width: 100%" size="mini"
						:disabled="importStatus === 'uploading'">
						<el-option v-for="item in floorArr" :key="item.id" :label="item.title" :value="item.id" />
					</el-select>
				</el-form-item>
				<div class="upload-container">
				<el-upload class="upload-demo" drag
					:auto-upload="false" action="" :disabled="importStatus === 'uploading'"
					:on-change="onImportFileChange" accept=".xls,.xlsx,.zip" :show-file-list="false">
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">
							将文件拖到此处，或<em>点击上传</em>
						</div>
					</el-upload>
				</div>
				<div v-if="importFile && importStatus !== 'uploading'" style="padding: 8px 0; text-align: center; color: #67C23A;">
					<i class="el-icon-document-checked"></i> 已选择: {{ importFile.name }}
				</div>
			</el-form>
			<div v-if="importStatus === 'uploading'" style="padding: 0 20px 16px;">
				<el-progress :percentage="importProgress" :stroke-width="18" status="success"
					:text-inside="true" :format="(p) => p + '%'"></el-progress>
				<p style="text-align: center; color: #909399; font-size: 13px; margin-top: 8px;">正在导入，请稍候...</p>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitImport" :loading="importStatus === 'uploading'"
					:disabled="!importFile || importStatus === 'uploading'">开始导入</el-button>
				<el-button @click="getouts">取 消</el-button>
			</div>
		</el-dialog>
		<el-dialog :title="title" :visible.sync="addOrEditOpen" :close-on-click-modal="false" width="45%"
			class="dialogHeight2 global-dialog-position" :before-close="getout" :lock-scroll="false"
			:append-to-body="true" style="margin-top: -10vh">
			<el-form ref="form" :model="form" label-width="100px" :rules="rules">
				<el-row :gutter="20">
					<el-col :span="24">
						<el-form-item label="车位类型" prop="carport_type">
							<el-input v-model="form.carport_type" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="车位编号" prop="carport_title">
							<el-input v-model="form.carport_title" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="价格" prop="price">
							<el-input v-model="form.price" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="原价" prop="origin_price">
							<el-input v-model="form.origin_price" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="租售类型">
							<el-select style="width: 100%" placeholder="请选择" clearable v-model="form.rent_sale_type">
								<el-option v-for="item in rentSaleTypes" :key="item.id" :label="item.title"
									:value="item.id" />
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="租金（/月）" prop="rent_price">
							<el-input v-model="form.rent_price" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="客户姓名">
							<el-input v-model="form.realname" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="客户电话">
							<el-input v-model="form.mobile" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="楼层名称" required>
							<el-select style="width: 100%" placeholder="请选择" clearable @change="getArea"
								v-model="form.floor_id">
								<el-option v-for="item in floorArr" :key="item.id" :label="item.title"
									:value="item.id" />
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="区域名称" prop="area_id">
							<el-select style="width: 100%" v-model="form.area_id" placeholder="请选择" clearable
								@change="$forceUpdate()">
								<el-option v-for="item in districtArr" :key="item.id" :label="item.title"
									:value="item.id" />
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="初始收藏" prop="sc_num">
							<el-input v-model="form.sc_num" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="初始热度" prop="hot_num">
							<el-input v-model="form.hot_num" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>

					<el-col :span="24">
						<el-form-item label="vr链接">
							<el-input v-model="form.vr_url" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="车位亮点">
							<el-input v-model="form.advantage" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="月租" prop="monthly_rent">
							<el-input v-model="form.monthly_rent" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="管理费" prop="management">
							<el-input v-model="form.management" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="x坐标">
							<el-input v-model="form.x" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="y坐标">
							<el-input v-model="form.y" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="角度">
							<el-input v-model="form.angle" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="租金租期配置">
							<div style="margin-bottom: 10px;">
								<el-button type="primary" size="small" icon="el-icon-plus"
									@click="addRentPriceRule">添加租期-租金</el-button>
							</div>
							<el-table :data="rentPriceRuleList" border size="small" style="width: 100%"
								:header-cell-style="{background:'#f5f7fa',color:'#606266',fontWeight:'600'}">
								<el-table-column label="租期（天）" align="center">
									<template slot-scope="scope">
										<el-select v-model="scope.row.tenancy" placeholder="选择租期" size="small"
											style="width: 120px">
											<el-option v-for="t in tenancyOptions" :key="t" :label="t"
												:value="String(t)" />
										</el-select>
									</template>
								</el-table-column>
								<el-table-column label="租金（元）" align="center">
									<template slot-scope="scope">
										<el-input-number v-model="scope.row.rentPrice" :min="0" :precision="2"
											controls-position="right" size="small"
											style="width: 140px"></el-input-number>
									</template>
								</el-table-column>
								<el-table-column label="操作" align="center" width="100">
									<template slot-scope="scope">
										<el-button type="danger" size="mini" icon="el-icon-delete"
											@click="removeRentPriceRule(scope.$index)">删除</el-button>
									</template>
								</el-table-column>
							</el-table>
							<div v-if="rentPriceRuleList.length === 0"
								style="text-align:center;color:#909399;padding:20px 0;font-size:13px;">
								暂无租金配置，点击「添加租期-租金」新增
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="收费/免费:" prop="management_status">
							<el-radio-group v-model="form.management_status">
								<el-radio v-for="item in priceStatus" :label="item.label"
									:key="item.label">{{ item.text }}</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="车位状态:" prop="carport_status">
							<el-radio-group v-model="form.carport_status">
								<el-radio v-for="item in regioncarTypes" :label="item.label" :key="item.label"
									:disabled="item.label == 2 || item.label == 5 || item.label == 6 || item.label == 7 ">{{ item.text }}</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="车位图片:" prop="image">
							<el-upload class="avatar-uploader" :action="uploadImgUrl" :show-file-list="false"
								:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :headers="headers"
								:disabled="true">
								<div class="avatar-wrapper">
									<el-image :preview-src-list="[imageUrl]" v-if="imageUrl" :src="imageUrl"
										class="avatar" />
									<i v-if="imageUrl" class="el-icon-close" @click.stop="removePic"></i>
									<i v-else class="el-icon-picture-outline avatar-uploader-icon"
										@click="uploadPicIcon"></i>
								</div>
							</el-upload>
							<div class="chooseImg">
								<el-button type="info" @click="chooseImg()">选择图片</el-button>
								<el-input v-model="imageUrl" autocomplete="off" placeholder="请输入图片地址" />
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="车位扩展图片:">
							<div class="avatar-wrapper" v-for="carport_thumb_ext in form.carport_thumb_extend"
								:key="carport_thumb_ext">
								<el-image v-if="carport_thumb_ext" :src="carport_thumb_ext"
									:preview-src-list="[form.carport_thumb_extend]" class="avatar" />
								<i class="el-icon-close" @click.stop="removePic1(carport_thumb_ext)"></i>
								<el-input :value="carport_thumb_ext" disabled autocomplete="off" placeholder="请输入" />
							</div>
							<div class="chooseImg">
								<el-button type="info" @click="chooseImg2()">选择图片</el-button>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForms">确 定</el-button>
				<el-button @click="getout">取 消</el-button>
			</div>
		</el-dialog>
		<el-dialog title="图片" :visible.sync="upImg" :close-on-click-modal="false" width="85%"
			class="dialogHeight global-dialog-position" style="margin-top: -5vh">
			<imgUpload ref="imgUpload" />
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitFormz">确 定</el-button>
			</div>
			<div slot="body" style="height: 50vh"></div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getCarList,
		editCar,
		addCar,
		deleteCar,
		delscar,
	} from "../../api/parking";
	import {
		getregionList
	} from "../../api/region";
	import {
		getFloorList
	} from "../../api/floor";
	import tableCommon from "../../../mixins/table-common";
	import {
		getCookie
	} from "../../utils/util";
	import {
		getFloor
	} from "../../api/garage";
	import {
		getRentTenancy
	} from "../../api/community";
	import axios from "axios";
	import imgUpload from "../../components/uploadImg.vue";
	export default {
		mixins: [tableCommon],
		components: {
			imgUpload,
		},
		data() {
			return {
				upImg: false,
				// 楼层id
				floorId: {},
				// 楼层数组
				floorArr: [],
				importOpen: false,
				diaIf: false,
				priceStatus: [{
						label: 1,
						text: "收费",
					},
					{
						label: 0,
						text: "免费",
					},
				],
				// 车位状态
				regioncarTypes: [{
						label: 1,
						text: "在售",
					},
					{
						label: 2,
						text: "锁定",
					},
          {
            label: 5,
            text: "已租赁",
          },
					{
						label: 7,
						text: "认购",
					},
					{
						label: 6,
						text: "签约",
					},
					{
						label: 4,
						text: "销控",
					},
				],
				rentSaleTypes: [{
						id: 1,
						title: '租赁'
					},
					{
						id: 2,
						title: '出售'
					},
					{
						id: 3,
						title: '租赁或出售'
					}
				],
				api: {
					list: getCarList,
					add: addCar,
					edit: editCar,
					del: deleteCar,
					dels: delscar,
				},

				// 导入弹窗
				importOpen: false,
				// 导出弹窗
				postOpen: false,
				floorRule: {
					floor_id: [{
						required: true,
						message: "请选择导出楼层",
						trigger: "change"
					}, ],
				},
				// 规则验证
				rules: {
					carport_type: [{
						required: true,
						message: "请输入类型",
						trigger: "blur"
					}, ],
					// rent_sale_type: [{
					// 	required: true,
					// 	message: "请选择租售类型",
					// 	trigger: "change"
					// }],
					carport_title: [{
						required: true,
						message: "请输入车位编号",
						trigger: "blur"
					}, ],
					// price: [{ required: true, message: "请输入价格", trigger: "blur" }],
					realname: [{
						required: true,
						message: "请输入名称",
						trigger: "blur"
					}],
					mobile: [{
						required: true,
						message: "请输入号码",
						trigger: "blur"
					}],
				},
				// 传参
				form: {
					status: "1",
					building_id: "",
					area_id: "",
				},
				// 弹窗标题
				title: "新增",
				addOrEditOpen: false,
				// 查询参数
				searchForm: {
					page: 1,
					pageSize: 15,
				},
				// 列表数据
				tableList: [],
				// 请求id
				id: "",
				// 分页
				total: 0,
				appOpen: false,
				// 小程序码
				appUrl: "",
				// 回传id
				lastId: "",
				// 区域下拉
				districtArr: [],
				// 导入上传
				uploadParams: {},
				// 楼层id
				floor_id: "",
				// 楼层
				floorArr: [],
				// 图片地址
				imageUrl: "",
				// 上传头文件
				headers: {
					Authorization: "Bearer " + getCookie("logintoken"),
				},
				// 车位上传
				uploadfloorUrl: process.env.VUE_APP_URL + "/admin/carpark/floorImport",
				// 图片上传地址
				uploadImgUrl: process.env.VUE_APP_URL + "/admin/uploadFile",
				// 导出地址
				exportUrl: process.env.VUE_APP_URL + "/admin/carpark/floorExport",
				imgFirst: false,
				imgSecond: false,
				// 车位初始状态
				carport_status: -1,
				// 导入进度
				importFile: null,
				importStatus: 'idle', // idle | uploading | success | error
				importProgress: 0,
				// 租期选项（来自小区 rent_tenancy）
				tenancyOptions: [],
				// 租金配置编辑数组
				rentPriceRuleList: [],
			};
		},
		watch: {
			upImg(newVal) {
				if (newVal) {
					this.$nextTick(() => {
						this.$refs.imgUpload.resetSelect();
					});
				}
			},
			// 监听floor_id的变化
			"form.floor_id": {
				handler(newValue) {
					this.form.area_id = "";
				},
			},
		},
		mounted() {
			this.searchForm.carpark_id = this.$route.query.id;
			this.uploadParams.floor_id = this.$route.query.id;
			this.initList();
			this.getFloorLists();
			this.fetchTenancyOptions();
		},
		methods: {
			// 获取小区租期选项
			fetchTenancyOptions() {
				getFloor(this.searchForm.carpark_id).then(res => {
					if (res.code == 200 && res.data) {
						const xiaoquId = res.data.xiaoqu_id;
						if (xiaoquId) {
							getRentTenancy(xiaoquId).then(cRes => {
								if (cRes.code == 200 && cRes.data) {
									this.tenancyOptions = cRes.data;
								}
							});
						}
					}
				});
			},
			getRentSaleTypeTitle(id) {
				let rst = this.rentSaleTypes.find(item=>item.id == id);
				return rst ? rst.title: '';
			},
			uploadPicIcon() {
				this.$message.warning("请点击下方选择图片按钮进行上传");
			},
			submitFormz() {
				if (this.$refs.imgUpload.faData.url) {
					if (this.imgFirst && this.$refs.imgUpload.faData.url !== undefined) {
						this.$refs.imgUpload.findTrue();
						this.imageUrl = this.$refs.imgUpload.faData.url;
						this.form.carport_thumb = this.$refs.imgUpload.faData.url;
						this.upImg = false;
					} else if (this.imgSecond && this.$refs.imgUpload.faData.url !== undefined) {
						var addImgs = []
						this.$refs.imgUpload.faDatas.forEach(item => {
							if (!this.form.carport_thumb_extend || !this.form.carport_thumb_extend.includes(item
									.url)) {
								addImgs.push(item.url)
							}
						})
						if (addImgs.length) {
							if (this.form.carport_thumb_extend) {
								this.form.carport_thumb_extend.splice(0, 0, ...addImgs)
							} else {
								this.form.carport_thumb_extend = addImgs
							}
						}
						this.upImg = false;
					}
				} else {
					this.$message.warning("请选择一张照片");
				}
			},
			chooseImg() {
				this.imgFirst = true;
				this.imgSecond = false;
				this.upImg = true;
			},
			chooseImg2() {
				this.imgFirst = false;
				this.imgSecond = true;
				this.upImg = true;
			},
			// 添加租期-租金规则
			addRentPriceRule() {
				this.rentPriceRuleList.push({ tenancy: '', rentPrice: 0 });
			},
			// 删除租期-租金规则
			removeRentPriceRule(index) {
				this.rentPriceRuleList.splice(index, 1);
			},
			// 点击清空事件
			clearInput() {
				this.searchForm.floor_id = undefined;
				this.initList();
			},
			clearRentSaleTypes() {
				this.searchForm.rent_sale_type = undefined;
				this.initList();
			},
			clearInputs() {
				this.searchForm.carport_title = undefined;
				this.initList();
			},
			// 移除图片
			removePic() {
				this.imageUrl = "";
				this.form.carport_thumb = "";
			},
			removePic1(item) {
				let index = this.form.carport_thumb_extend.indexOf(item)
				if (index > -1) {
					this.form.carport_thumb_extend.splice(index, 1)
				}
				this.$forceUpdate();
			},
			// 导出
			postTrue() {
				this.postOpen = true;
				this.$nextTick(() => {
					this.$refs.floorRule.clearValidate();
				});
				this.title = "导出";
			},
			postSubmit() {
				this.$refs["floorRule"].validate((valid, err) => {
					if (valid) {
						this.filePut();
					}
				});
			},
			filePut() {
				return axios({
						// 用axios发送get请求
						url: this.exportUrl, // 请求地址
						params: {
							floor_id: this.floorId.floor_id,
						}, // 参数
						method: "get",
						responseType: "blob",
						headers: {
							"Content-Type": "application/json",
							Authorization: "Bearer " + getCookie("logintoken"),
						},
					})
					.then((res) => {
						console.log(res);
						const fileName = "车位导出文件";
						// 处理返回的文件流
						/* 兼容ie内核，360浏览器的兼容模式 */
						const blob = new Blob([res.data], {
							type: "application/vnd.ms-excel;charset=utf-8",
						});
						/* 兼容ie内核，360浏览器的兼容模式 */
						if (window.navigator && window.navigator.msSaveOrOpenBlob) {
							window.navigator.msSaveOrOpenBlob(blob, fileName);
						} else {
							/* 火狐谷歌的文件下载方式 */
							let url1 = window.URL.createObjectURL(blob);
							let link = document.createElement("a");
							link.style.display = "none";
							link.href = url1;
							link.setAttribute("download", fileName);
							document.body.appendChild(link);
							link.click();
						}
						this.$message.success("成功");
						this.postOpen = false;
						return Promise.resolve(res.data);
					})
					.catch((err) => {
						this.$message.error("失败");
						return Promise.resolve(err);
					});
			},
			// 导入弹窗
			fileAdd() {
				this.importOpen = true;
				this.title = "导入";
				this.importFile = null;
				this.importStatus = 'idle';
				this.importProgress = 0;
			},
		// 文件选择变化
		onImportFileChange(file, fileList) {
			console.log('onImportFileChange:', file, fileList);
			if (file && file.raw) {
				this.importFile = file;
				this.importProgress = 0;
				this.importStatus = 'idle';
				this.$message.success('文件已选择: ' + file.name);
			}
		},
			// 提交导入（带进度条）
			submitImport() {
				if (!this.floorId.floor_id) {
					this.$message.error("请先选择导入楼层！");
					return;
				}
				if (!this.importFile) {
					this.$message.warning("请先选择文件");
					return;
				}
				this.importStatus = 'uploading';
				this.importProgress = 0;

				const formData = new FormData();
				formData.append('import_file', this.importFile.raw);
				formData.append('floor_id', this.floorId.floor_id);

				axios({
					url: this.uploadfloorUrl,
					method: 'post',
					data: formData,
					headers: { ...this.headers, 'Content-Type': 'multipart/form-data' },
					onUploadProgress: (progressEvent) => {
						console.log('上传进度:', progressEvent.loaded, '/', progressEvent.total);
					if (progressEvent.total > 0) {
						this.importProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
						if (this.importProgress >= 99) {
							this.importProgress = 95; // 卡在95等后端响应
						}
					}
				},
			}).then(res => {
				this.importProgress = 100;
				console.log('导入响应:', res);
				// 后端返回格式: {"code":200,"msg":"操作成功","data":{"code":401,"msg":"...","data":null}}
				// 需要判断 res.data.code 才是真正的业务状态码
				if (res.data && res.data.code == 200) {
					this.importStatus = 'success';
					// 弹窗确认
					this.$confirm('车位数据导入成功！', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '',
						type: 'success',
					}).then(() => {
						this.resetImportState();
						this.initList();
					}).catch(() => {});
				} else {
					this.importStatus = 'error';
					const errorMsg = res.data ? (res.data.msg || '上传失败') : (res.msg || '上传失败');
					this.$message.error(errorMsg);
				}
			}).catch(err => {
				this.importStatus = 'error';
				console.error('导入错误:', err);
				this.$message.error('上传失败: ' + (err.message || '网络错误'));
			});
		},
			// 重置导入状态
			resetImportState() {
				this.importOpen = false;
				this.importFile = null;
				this.importStatus = 'idle';
				this.importProgress = 0;
			},
			beforeAvatarUpload(file) {
				const isJPG =
					file.type === "image/jpeg" ||
					file.type === "image/png" ||
					file.type === "image/jpeg" ||
					file.type === "image/webp";
				const isLt2M = file.size / 1024 / 1024 < 2;

				if (!isJPG) {
					this.$message.error("上传头像图片只能是 JPG 格式!");
				}
				return isJPG;
			},
			// 图片
			handleAvatarSuccess(res, file) {
				this.imageUrl = res.data.path;
				this.form.carport_thumb = this.imageUrl;
				this.$forceUpdate(); // 强制更新视图
			},
			getArea(res) {
				// 由楼层选区域
				const areaData = {
					floor_id: res,
				};
				getregionList(areaData).then((res) => {
					this.districtArr = res.data.data;
				});
			},
			// 楼层
			getFloorLists() {
				const floorForm = {
					carpark_id: this.$route.query.id,
				};
				getFloorList(floorForm).then((res) => {
					this.floorArr = res.data.records;
				});
			},
			// 搜索重置
			resets() {
				this.searchForm = {
					carport_title: undefined,
					carpark_id: this.$route.query.id,
				};
				this.initList();
			},
			// 重置
			reset() {
				this.form = {
					status: undefined,
					title: undefined,
					carport_thumb_extend: [],
				};
			},
			// 新增弹窗
			handleNewAdd() {
				this.title = "新增";
				this.reset();
				this.handleAdd();
			},
			// 修改弹窗
			handleClick(row) {
				this.title = "修改";
				this.form = JSON.parse(JSON.stringify(row));
				this.carport_status = this.form.carport_status;
				this.imageUrl = this.form.carport_thumb;

				if (this.$refs.imgUpload) {
					this.$refs.imgUpload.faData.url = "";
				}
				const {
					city_name,
					created_at,
					share_img,
					...rest
				} = row;
				this.form = rest;
				if (this.form.carport_thumb_extend) {
					this.form.carport_thumb_extend = this.form.carport_thumb_extend.split(',');
				} else {
					this.form.carport_thumb_extend = [];
				}
				// 解析 rent_price_rule JSON 字符串为编辑数组
				if (this.form.rent_price_rule) {
					try {
						this.rentPriceRuleList = JSON.parse(this.form.rent_price_rule);
					} catch (e) {
						this.rentPriceRuleList = [];
					}
				} else {
					this.rentPriceRuleList = [];
				}
				this.handleEdit();
			},
			// 关闭弹窗
			getout() {
				this.addOrEditOpen = false;
				this.$refs.form.clearValidate();
				this.imageUrl = "";
			},
			// 关闭导入导出
			getouts() {
				this.floorId = {
					floor_id: undefined,
				};
				this.importOpen = false;
				this.postOpen = false;
			},
			// 提交
			submitForms() {
				if (!this.form.area_id) {
					this.form.area_id = 0;
				}
				if (this.form.carport_thumb_extend.length) {
					this.form.carport_thumb_extend = this.form.carport_thumb_extend.join()
				} else {
					this.form.carport_thumb_extend = '';
				}
				// 校验租期不能重复
				if (this.rentPriceRuleList.length) {
					const tenancySet = new Set();
					for (const rule of this.rentPriceRuleList) {
						if (!rule.tenancy) {
							this.$message.warning('请选择租期');
							return;
						}
						if (tenancySet.has(rule.tenancy)) {
							this.$message.warning('租期不能重复，请检查配置');
							return;
						}
						tenancySet.add(rule.tenancy);
					}
					this.form.rent_price_rule = JSON.stringify(this.rentPriceRuleList);
				} else {
					this.form.rent_price_rule = '';
				}
				this.submitForm();
			},
		},
	};
</script>
<style scoped>
	/deep/.dialogHeight2 .el-dialog__body {
		overflow-y: auto;
	}

	/deep/.dialogHeight .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	.chooseImg {
		display: flex;
		align-items: center;
	}

	/deep/.el-table,
	.el-table th,
	.el-table td {
		border-radius: 10px;
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizeLegibility;
		font-size: 16px;
		font-family: Times, "Times New Roman";
		/* font-weight: 600; */
	}

	.topNav {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #fff;
		padding: 20px 20px;
		border-radius: 10px;
	}

	.navFormWrapper {
		display: flex;
		align-items: center;
	}

	.upload-container {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409eff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 150px;
		height: 150px;
		line-height: 150px;
		text-align: center;
		border: 1px solid #dcdfe6;
	}

	.avatar {
		width: 150px;
		height: 150px;
		display: block;
	}

	.avatar-wrapper {
		position: relative;
	}

	.el-icon-close {
		position: absolute;
		top: 0;
		right: 45vh;
		cursor: pointer;
	}

	.el-icon-close:hover {
		color: #409eff;
	}

	.avatar-wrapper .el-icon-close {
		position: absolute;
		top: 5px;
		right: 5px;
		font-size: 18px;
		color: #fff;
		background-color: rgba(0, 0, 0, 0.5);
		padding: 5px;
		border-radius: 50%;
		cursor: pointer;
	}

	/deep/ .el-dialog__body {
		height: 60vh;
	}
</style>



// WEBPACK FOOTER //
// src/views/garage/parking.vue